import Content from 'components/ThreePage/Content/Content';
import React from 'react';

const ThreePage = () => {
  return <Content />;
};

export default ThreePage;
